export default "__VITE_ASSET__DEJbiF$k__"